import axios from "axios";
import { useEffect, useState } from "react";
import { Building, Save } from "lucide-react";
import { INVOICE_CURRENCIES } from "../lib/invoice";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TEXT_FIELDS = [
  ["company_name", "Şirket ünvanı"],
  ["company_address", "Adres"],
  ["company_phone", "Telefon"],
  ["company_email", "E-posta"],
  ["company_trn", "TRN"],
  ["next_number", "Numaratör başlangıcı"],
];

const AREA_FIELDS = [
  ["terms", "Şartlar (her satır ayrı madde)"],
  ["note", "Not"],
  ["bank_details", "Banka bilgileri (her satır ayrı)"],
  ["footer_text", "Alt yazı"],
];

export default function InvoiceSettings() {
  const [form, setForm] = useState(null);
  const [notice, setNotice] = useState("");

  useEffect(() => {
    axios.get(`${API}/invoices/settings`).then(r => setForm(r.data)).catch(() => setForm({}));
  }, []);

  const set = (key, value) => setForm(current => ({ ...current, [key]: value }));

  const save = async event => {
    event.preventDefault();
    try {
      const { data } = await axios.put(`${API}/invoices/settings`, {
        ...form,
        default_rate: Number(form.default_rate) || 1,
        vat_rate: Number(form.vat_rate) || 0,
      });
      setForm(data);
      setNotice("Fatura ayarları kaydedildi");
    } catch (e) {
      setNotice(e?.response?.data?.detail || "Kaydedilemedi");
    }
  };

  if (!form) return null;

  return (
    <section className="panel invoice-settings" data-testid="invoice-settings">
      <div className="panel-head">
        <div>
          <p className="eyebrow">FATURA AYARLARI</p>
          <h3>Şirket, kur ve kaşe bilgileri</h3>
        </div>
        <Building size={18}/>
      </div>
      <form onSubmit={save} className="edit-form">
        {TEXT_FIELDS.map(([key, label]) => (
          <div className="field" key={key}>
            <label>{label}</label>
            <input data-testid={`invoice-setting-${key}`} value={form[key] || ""} onChange={e => set(key, e.target.value)}/>
          </div>
        ))}
        <div className="form-row">
          <div className="field">
            <label>Varsayılan kur</label>
            <input data-testid="invoice-setting-default_rate" type="number" step="0.0001" min="0.0001"
              value={form.default_rate ?? ""} onChange={e => set("default_rate", e.target.value)}/>
          </div>
          <div className="field">
            <label>VAT oranı (%)</label>
            <input data-testid="invoice-setting-vat_rate" type="number" step="0.1" min="0" max="100"
              value={form.vat_rate ?? ""} onChange={e => set("vat_rate", e.target.value)}/>
          </div>
        </div>
        <div className="form-row">
          <div className="field">
            <label>Varsayılan kalem para birimi</label>
            <select data-testid="invoice-setting-item_currency" value={form.item_currency || "USD"} onChange={e => set("item_currency", e.target.value)}>
              {INVOICE_CURRENCIES.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div className="field">
            <label>Varsayılan fatura para birimi</label>
            <select data-testid="invoice-setting-total_currency" value={form.total_currency || "AED"} onChange={e => set("total_currency", e.target.value)}>
              {INVOICE_CURRENCIES.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        </div>
        {AREA_FIELDS.map(([key, label]) => (
          <div className="field" key={key}>
            <label>{label}</label>
            <textarea rows={key === "bank_details" || key === "terms" ? 5 : 2} data-testid={`invoice-setting-${key}`}
              value={form[key] || ""} onChange={e => set(key, e.target.value)}/>
          </div>
        ))}
        <label className="check-line">
          <input type="checkbox" data-testid="invoice-setting-show_stamp" checked={form.show_stamp !== false}
            onChange={e => set("show_stamp", e.target.checked)}/>
          <span>PDF'e kaşe ve imzayı bas</span>
        </label>
        <label className="check-line">
          <input type="checkbox" data-testid="invoice-setting-vat_included" checked={form.vat_included !== false}
            onChange={e => set("vat_included", e.target.checked)}/>
          <span>Yeni faturalarda tutar VAT dahil kabul edilsin</span>
        </label>
        <button type="submit" className="primary-btn" data-testid="save-invoice-settings"><Save size={15}/> Kaydet</button>
        {notice && <small className="group-notice" data-testid="invoice-settings-notice">{notice}</small>}
      </form>
    </section>
  );
}
